import styled from 'styled-components';
import { IconButton } from '@web-chat-core/ui-kit';

// TODO: SIP. Создать общую кнопку на основе IconButton
export const ToogleLayoutButton = styled(IconButton)`
    height: 40px;
    width: 40px;

    &:before {
        background: ${(props) => props.theme.root.colors.basicColors['10%']};
    }

    &:hover:before {
        background: ${(props) => props.theme.root.colors.basicColors['15%']};
    }

    &:after {
        right: 0;
        left: auto;
        transform: translateY(-100%);
        white-space: nowrap;
    }
`;
